import { useMutation } from '@apollo/client';
// Types
import { CREATE_CAMPAIGN_DELIVERABLES_FILES } from 'api/campaignV2/mutations';
import {
  CreateCampaignDeliverableFiles,
  CreateCampaignDeliverableFilesVariables,
} from 'api/campaignV2/types/CreateCampaignDeliverableFiles';
// Helpers
import { uploadDeliverables } from 'helpers/campaign';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useUploadCampaignFiles = () => {
  const [createCampaignDeliverableFiles] = useMutation<
    CreateCampaignDeliverableFiles,
    CreateCampaignDeliverableFilesVariables
  >(CREATE_CAMPAIGN_DELIVERABLES_FILES);

  return {
    createCampaignDeliverableFiles,
    uploadDeliverables,
  };
};
